import { color } from '../../../resources/color';
export const textStyle = {
  textTitle: {
    color: color.clear,
    fontSize: 18,
  },
  textContent: {
    fontSize: 18,
  },
};
